import { addDeductionApi } from './addDeduction.api';
import { deletedDeductionApi } from './deleteDeduction.api';
import { editRetailerChargesApi } from './editRetailerDetails.api';
import { editTdsApi } from './editTds.api';
import { editTransportChargesApi } from './editTransportCharges.api';
import { initPaymentDetailsApi } from './initPayment.api';
import { rejectionReasonApi } from './rejectionReason.api';

// moved here from the paymentsV2
import { retailerPaymentDetailsApi } from './retailerPayment.api';
import { transportPaymentDetailsApi } from './transportPayment.api';
import { fetchDocumentsApi } from './fetchDocumentDetails.api';
import { gstPaymentDetailsApi } from './gstPayment.api';

export const paymentTrenchesApi = [
	rejectionReasonApi,
	addDeductionApi,
	initPaymentDetailsApi,
	deletedDeductionApi,
	editTdsApi,
	editTransportChargesApi,
	editRetailerChargesApi,
];

// moved here from the paymentsV2
export const paymentApis = [
	retailerPaymentDetailsApi,
	gstPaymentDetailsApi,
	transportPaymentDetailsApi,
	fetchDocumentsApi,
];

export * from './rejectionReason.api';
export * from './addDeduction.api';
export * from './initPayment.api';
export * from './deleteDeduction.api';
export * from './editTds.api';
export * from './editTransportCharges.api';
export * from './editRetailerDetails.api';

// moved here from the paymentsV2
export * from './retailerPayment.api';
export * from './gstPayment.api';
export * from './transportPayment.api';
export * from './fetchDocumentDetails.api';
